module.exports = __webpack_public_path__ + "media/src/images/certificates/milestone_uncompleted_old-985d4c449ac05d1a5e0a7cc6082c2fc7.png";